import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-457cab1a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "center"
};
const _hoisted_2 = {
  class: "ant-upload-text"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createTextVNode("点击上传或拖动"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("文件到此处")], -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "remark"
}, "(支持excel格式)", -1));
const _hoisted_5 = {
  key: 0,
  class: "mrt25"
};
import { CloudDownloadOutlined, PlusOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import { uploadFile } from '@/api/upload.js';
import { downLocalFile } from '@/api/utils';

import { ref } from 'vue';
export default {
  __name: 'index',
  emits: ['reset'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const $emit = __emit;
    const month = ref('');
    const uploadUrl = ref('');
    const downloadUrl = ref('');
    const exportName = ref('');
    const fileList = ref([]);
    const modalOpen = ref(false);
    const saveLoading = ref(false);
    const downTempLoading = ref(false);
    const fileUrl = ref(null);

    // 打开
    function open(upUrl, downUrl, name) {
      uploadUrl.value = upUrl;
      downloadUrl.value = downUrl || '';
      exportName.value = name || '';
      fileList.value = [];
      fileUrl.value = null;
      modalOpen.value = true;
    }

    // 上传后的回调
    function handleLogoChange(info) {
      fileUrl.value = info.fileList[0].originFileObj;
    }
    // 上传之前的校验
    function beforeUpload(file) {
      if (!file.type) {
        if (file.name && !file.name.includes('.xls') && !file.name.includes('.xlsx')) {
          message.error('只支持excel文件');
          return false;
        }
      } else if (file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' && file.type !== 'application/vnd.ms-excel') {
        message.error('只支持excel文件');
        return false;
      }
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isLt2M) message.error('文件不能超过 5MB!');
      return false;
    }

    //   保存
    function saveData() {
      if (fileUrl.value) {
        saveLoading.value = true;
        const formData = new FormData();
        formData.append('file', fileUrl.value);
        uploadFile(uploadUrl.value, formData).then(res => {
          if (res.code === '0') {
            message.success('上传成功');
            $emit('reset');
            handleClose();
          } else {
            message.error(res.message);
          }
        }).finally(() => {
          saveLoading.value = false;
        });
      }
    }

    //   下载模板
    function downTemplate() {
      downTempLoading.value = true;
      downLocalFile(downloadUrl.value, `${exportName.value}模板.xlsx`).then(() => {
        setTimeout(() => {
          downTempLoading.value = false;
        }, 1000);
      });
    }

    // 关闭弹窗
    function handleClose() {
      fileList.value = [];
      fileUrl.value = null;
      modalOpen.value = false;
    }
    __expose({
      open
    });
    return (_ctx, _cache) => {
      const _component_a_upload = _resolveComponent("a-upload");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_a_modal, {
        open: _unref(modalOpen),
        "onUpdate:open": _cache[1] || (_cache[1] = $event => _isRef(modalOpen) ? modalOpen.value = $event : null),
        "mask-closable": false,
        title: "导入",
        onOk: handleClose
      }, {
        footer: _withCtx(() => [_createVNode(_component_a_button, {
          key: "back",
          onClick: handleClose
        }, {
          default: _withCtx(() => [_createTextVNode(" 取消 ")]),
          _: 1
        }), _createVNode(_component_a_button, {
          key: "submit",
          type: "primary",
          loading: _unref(saveLoading),
          onClick: saveData
        }, {
          default: _withCtx(() => [_createTextVNode(" 确定 ")]),
          _: 1
        }, 8, ["loading"])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_a_upload, {
          "file-list": _unref(fileList),
          "onUpdate:fileList": _cache[0] || (_cache[0] = $event => _isRef(fileList) ? fileList.value = $event : null),
          size: "large",
          name: "avatar",
          class: "avatar-uploader",
          "max-count": 1,
          "show-upload-list": true,
          "before-upload": beforeUpload,
          onChange: handleLogoChange
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_unref(PlusOutlined)), _hoisted_3, _hoisted_4])]),
          _: 1
        }, 8, ["file-list"]), _unref(downloadUrl) ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_a_button, {
          type: "primary",
          ghost: "",
          loading: _unref(downTempLoading),
          onClick: downTemplate
        }, {
          default: _withCtx(() => [_createVNode(_unref(CloudDownloadOutlined)), _createTextVNode("点击下载" + _toDisplayString(_unref(exportName)) + "模板 ", 1)]),
          _: 1
        }, 8, ["loading"])])) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["open"])]);
    };
  }
};